<span #yarntypes class="yarn-types" [matTooltipDisabled]="!showTooltip" [matTooltip]="getYarnTypes()" (click)="showYarnSetDetails($event)">
  {{ getYarnTypes() }}
</span>
